import React from "react"
import Jumbotron from "react-bootstrap/Jumbotron"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import IntroBackground from "./IntroBackground"
import Reveal from "react-reveal/Reveal"
import Fade from "react-reveal/Fade"
import introStyles from "./intro.module.scss"

const Intro = () => {
  return (
    <IntroBackground>
      <section>
        <Jumbotron className={`mb-0 ${introStyles.jumbotron}`}>
          <Row>
            <Col className="m-auto" xs={12} sm={12} md={7} lg={8} xl={8}>
              <Reveal bottom forever={true}>
                <h2
                  className={`display-4 text-center diaplayHeading pb-3 ${introStyles.heading}`}
                >
                  Hypothetical Transmission
                </h2>
                <p className={`text-center ${introStyles.heading}`}>
                  My Futuristic site would be with Content like this...
                </p>
                <p className={introStyles.heading}>
                  Our inter planetary star ships (built with Extra terrestrial
                  object) have the speed at the rate of imagination which is
                  billion times faster than speed of light. You name the planet
                  we will take you there.
                </p>
                <p className={introStyles.heading}>
                  The possibilities of{" "}
                  <span className="text-primary">quantum teleportation </span>
                  looks more and more promising as new milestones are reached.
                  The speed of
                  <span className="text-primary"> Imagination </span> is achived
                  with
                  <span className="text-primary">
                    {" "}
                    Quantum Supremacy - QS.{" "}
                  </span>
                </p>
                <p className={introStyles.heading}>
                  Human spacecraft don't even crack a tenth of a percent of the
                  speed of light. But if you travel through our QS enabled
                  spacecraft in the universe You will travel through time into
                  the future. Nothing will feel different for you, but after a
                  couple of years' journeys you would return to the Earth to
                  find our clocks advanced by thousands or even tens of
                  thousands of years, depending on how fast you go.
                </p>
                <p className={introStyles.heading}>
                  So, the future is yours, and you get to choose how quickly you
                  reach it.
                </p>
              </Reveal>
              <Fade right>
                <h2
                  className={`display-4 text-center diaplayHeading pb-3 ${introStyles.heading}`}
                >
                  Welcome On Board
                </h2>
              </Fade>
              <Reveal bottom forever={true}>
                <p className={`mb-0 align-middle ${introStyles.heading}`}>
                  Your Astronaut :
                  <a
                    href="https://sungharsh.github.io/"
                    className={`float-right text-secondary`}
                    type="button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <abbr title="Read my Blog" className="text-left">
                      Sungharsh
                    </abbr>
                    <span className="text-danger">
                      <strong> &#62;</strong>
                    </span>
                  </a>
                </p>

                <hr className="mx-5 my-5 bg-secondary" />
                <p className={`blockquote text-right ${introStyles.heading}`}>
                  Drake’s Equation is a probabilistic estimate of the number of
                  intelligent civilizations in the Milky Way galaxy. It is not
                  an attempt to quantify intelligent civilizations precisely,
                  but to invoke humans’ curiosity of aliens’ existence. If you
                  are still reading this, 60 years after, then Drake has been
                  successful.
                  <br />
                  <span className="blockquote-footer text-right">
                    Theory by : &nbsp;
                    <cite
                      style={{ fontSize: "1.5rm" }}
                      title="https://en.wikipedia.org/wiki/Drake_equation"
                    >
                      Dr. Frank Drake (wikipedia)
                    </cite>
                  </span>
                </p>
              </Reveal>
            </Col>
          </Row>
        </Jumbotron>
      </section>
    </IntroBackground>
  )
}
export default Intro
